import * as nodeUtils from "../../abstract/controller/utils/nodeUtils";
import DefaultTooltip from "../ui/tooltips/DefaultTooltip";
import ElementTooltipComment from "./ElementTooltipComment";

const _limit = 20;

function TooltipComment({ node, handle, isHidden }) {
  if (isHidden) {
    return null;
  }

  const _comment = nodeUtils.getComment(node);

  if (!_comment) {
    return null;
  }

  if (_comment.length < _limit) {
    return null;
  }

  return (
    <DefaultTooltip handle={handle}>
      <ElementTooltipComment node={node} />
    </DefaultTooltip>
  );
}

export default TooltipComment;
